import React from 'react';
import './AboutUs.css';
import au1 from './au1.jpg';
import au2 from './au2.jpg';

const AboutUs = () => {
  return (
    <div className="about-us-container">
      <div className="about-us-content">
        <div className="story-card">
          <h2 className="story-card-title" style={{ fontSize: '2.8rem', fontWeight: 800, marginBottom: 32, letterSpacing: 0.5 }}>
            Our Story
          </h2>
          
          <div className="story-section">
            <div className="story-text">
              <p>
                Mickey's Subs was established in 2019 with a commitment to prioritizing quality ingredients. Founded by Mickey, who was inspired by his faith in God and supported by family and friends, the restaurant opened its doors in a renovated former Subway location. The onset of the pandemic posed significant challenges, yet through perseverance and dedication, Mickey managed to grow the business. Consistently emphasizing food quality and customer engagement, Mickey's Subs developed a reputation as a high-quality restaurant with a loyal clientele.
              </p>
            </div>
            <img src={au1} alt="Mickey's Subs" className="story-image" />
          </div>

          <div className="story-divider" />

          <div className="story-section">
            <img src={au2} alt="Mickey's Subs Recognition" className="story-image" />
            <div className="story-text">
              <p>
                In 2023, USA Today recognized Mickey's Subs as the highest-rated Google cheap eats restaurant in America. Located in Tampa's Westshore Marina District, the establishment continues to offer exceptional sub sandwiches and is planning future expansion. Mickey attributes the success of the business to meaningful customer relationships and his guiding principles. Today, Mickey's Subs is regarded as a staple in Tampa, celebrated for outstanding customer service and award-winning food.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
